export const ACCESS_TOKEN_EXPIRED_BUFFER = 3 / 4;

export const NEPES_WORKSPACES = ['nepes', 'nepesway', 'nepesway1', 'nepes100', 'tei1234'];
